import {APIParser, APIParserHtml, APIDownloadFile } from './api-parser';
import { API_URL, OLD_UI_URL } from './api-client'
import triyoAPI from './triyo';
import { config } from "../../util/axios-config"
/*
    Upload
*/
export const UploadDocumentForProject = (projectID, document) => {
    let documentJson = JSON.stringify(document);

    return fetch(API_URL + "uploaddocument/" + "0" + "/" + projectID, {
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

export const UpdateProjectDocument = (projectID, documentID, document) => {
    let documentJson = JSON.stringify(document);

    return fetch(API_URL + "updatedocument/" + "0" + "/" + projectID + "/" + documentID, {
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

/*
    Get Project Document
*/
export const GetProjectDocuments = (projectID) => {
    return fetch(API_URL + "getprojectdocuments/" + "0" + "/" + projectID)
         .then((response) => APIParser(response));
}

export const GetProjectDocument = (projectID, documentID) => {
    return fetch(API_URL + "getprojectdocument/" + "0" + "/" + projectID)
         .then((response) => APIParser(response));
}

//"https://cors-anywhere.herokuapp.com/" +

/*
    Word Api
*/

export const UpdateTaskWeb = (token, obj) => {
    let objJSON = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/UpdateTaskWeb/" + token, {
        method: 'POST',
        body: objJSON,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then((response) => APIParser(response));
}

export const ReassignWeb = (token, obj) => {
    let objJSON = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/ReassignWeb/" + token, {
        method: 'POST',
        body: objJSON,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
		},
    })
    .then((response) => APIParserHtml(response));
}

export const CancelAssignmentWeb = (token, taskID, commentObj) => {
    let objJSON = JSON.stringify(commentObj);

    return fetch(OLD_UI_URL + "web/Home/CancelAssignmentWeb/" + token + "/" + taskID, {
        method: 'POST',
        body: objJSON,
        headers: {
            'Content-Type': 'application/json',
		},
    })
    .then((response) => APIParser(response));
}

export const SendDocCollabReminder = (obj) => {

    let objJSON = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "api/ApiTest/SendDocCollabReminder/1", {
        method: 'POST',
        body: objJSON,
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then((response) => APIParser(response));
}

export const SendReminder = (obj) => {

    let objJSON = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "api/ApiTest/SendReminder/1", {
        method: 'POST',
        body: objJSON,
        headers: {
            'Content-Type': 'application/json',
		}
    })
    .then((response) => APIParser(response));
}

/*
    Powerpoint Api
*/

export const EditPPTWeb = (token, obj) => {
    let objJSON = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/EditPPTWeb/" + token, {
        method: 'POST',
        body: objJSON,
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then((response) => APIParser(response));
}

export const RequestReviewSlideWeb = (token, formData) => {

    return fetch(OLD_UI_URL + "web/Home/RequestReviewSlideWeb/" + token, {
        method: 'POST',
        body: formData,
        //not sure if headers/content type required
        headers: {
            'Content-Type': 'multipart/form-data',
            //'Content-Type': 'application/x-www-form-urlencoded',
        }
    })
    .then((response) => APIParser(response));
}

export const ApproveSlideWeb = (token, obj) => {
    let objJSON = JSON.stringify(obj);

    console.log(OLD_UI_URL + "web/Home/ApproveSlideWeb/" + token)
    return fetch(OLD_UI_URL + "web/Home/ApproveSlideWeb/" + token, {
        method: 'POST',
        body: objJSON,
        headers: {
            'Content-Type': 'application/json',
        }
    })
    // .then((response) => console.log(response));
    .then((response) => {return response});
}

export const DeclineSlideWeb = (token, obj) => {
    let objJSON = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/DeclineSlideWeb/" + token, {
        method: 'POST',
        body: objJSON,
        headers: {
            'Content-Type': 'application/json',
        }
    })
    // .then((response) => console.log(response));
    .then((response) => {return response});
}

export const GetAllSlidesWeb = (documentObj) => {
    let documentJson = JSON.stringify(documentObj);

    return fetch(OLD_UI_URL + "web/Home/GetAllSlidesWeb/1", {
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

export const GetMySlidesWeb = (documentObj) => {
    let documentJson = JSON.stringify(documentObj);
    return fetch(OLD_UI_URL + "web/Home/GetMySlidesWeb/1", {
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

export const GetAllBlackLineSlidesWeb = (documentObj) => {
    let documentJson = JSON.stringify(documentObj);

    return fetch(OLD_UI_URL + "web/Home/GetAllBlackLineSlidesWeb/1", {
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

//ADDING DOWNLOADPOWERPOINTWEB AND DOWNLOADPOWERPOINT
export const DownloadPowerpointWeb = (id, token) => {
    let documentJson = JSON.stringify(id);

    return fetch(OLD_UI_URL + "web/Home/DownloadPowerpointWeb/" + token,{
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIDownloadFile(response));
}

export const DownloadChangedPowerpointWeb = (id, token) => {
    let documentJson = JSON.stringify(id);

    return fetch(OLD_UI_URL + "web/Home/DownloadChangedPowerpointWeb/" + token,{
        method: 'POST',
        body: documentJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIDownloadFile(response));
}

/*
    Excel Api
*/

export const ViewExcelAssignedContent = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/LoadAssignedExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParserHtml(response));
}

export const DownloadExcelAssignedContentRow = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/GetAssignedUnchangedExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIDownloadFile(response));
}

export const DownloadExcelAssignedContentColumn = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/GetAssignedExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIDownloadFile(response));
}

export const ViewExcelChangedContent = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/LoadAssignedChangedExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParserHtml(response));
}

export const DownloadExcelChangedContentRow = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/GetAssignedChangedExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIDownloadFile(response));
}

export const DownloadExcelChangedContentColumn = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/GetAssignedExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIDownloadFile(response));
}

export const ViewExcelUpdatedContent = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/LoadOriginalExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParserHtml(response));
}

export const ExcelApprove = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/home/ApproveExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

export const ExcelDecline = (token, obj) => {
    let objJson = JSON.stringify(obj);

    return fetch(OLD_UI_URL + "web/Home/DeclineExcelWeb/" + token, {
        method: 'POST',
        body: objJson,
        headers: {
            'Content-Type': 'application/json',
        }}
        )
        .then((response) => APIParser(response));
}

// search results view documents
export const GetDocumentPDF = (name) => {

    let docName = JSON.stringify({
        'docName': name
    });

    return fetch(OLD_UI_URL + "/api/documentsapi/GetDocumentPDF/" + 0,
    {
        method: "POST",
        body: docName,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        }}
    ).then((response) => APIParser(response));
}

export const UpdateDocumentTaskWeb = (data) => {
    return triyoAPI.post("/tasks/SubmitTaskWordDocumentWeb", data, config());
};
